import { estimateTextHeight } from './estimateTextHeight.js';
import { formatAndAddEllipsis } from './formatAndAddEllipsis.js';

const MAX_CYCLES = 10;
const STEP = 1;
function truncateLastLine({
  label,
  targetHeight,
  targetWidth,
  characterWidths
}) {
  let newLabel = label;
  let lineStart = 0;
  let lineEnd = label.length;
  let counter = 0;

  if (lineEnd < lineStart) {
    return newLabel;
  }

  while (lineStart <= lineEnd && counter < MAX_CYCLES) {
    const middle = Math.floor((lineStart + lineEnd) / 2);
    newLabel = label.substring(0, middle);

    if (newLabel.length < label.length) {
      newLabel = formatAndAddEllipsis(newLabel);
    }

    const newLabelHeight = estimateTextHeight({
      label: newLabel,
      targetWidth,
      characterWidths
    });

    if (newLabelHeight === targetHeight) {
      break;
    }

    if (newLabelHeight > targetHeight) {
      lineEnd = middle - STEP;
    }

    if (newLabelHeight < targetHeight) {
      lineStart = middle + STEP;
    }

    counter += STEP;
  }

  return newLabel;
}

export { truncateLastLine };
